export default __webpack_public_path__ + "static/media/3.eec63529.jpg";